'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------- Component
/**
  * OrganisationSchema - Implements schema.org Website
  *
  * Describes a webpage
  *
  * @example
    <OrganisationSchema data={data}>
  *
  * @param {string} data.name - Name of the organisation
  * @param {string} data.legalName - Legal name or the organisation
  * @param {string} data.url - Homepage of the organisation
  * @param {string} data.logo - Logo
  * @param {string} data.foundingDate - Date the organisation was founded
  * @param {array} data.founders - A list of founding members
  * @param {string} data.streetAddress - Street address of the head office
  * @param {string} data.addressLocality - Locality of the head office
  * @param {string} data.addressRegion - Region of the organisation
  * @param {string} data.postalCode - Postal code of the region
  * @param {string} data.addressCountry - Country of the organisation
  * @param {array} data.telephone - Array of telephone numbers
  * @param {string} data.email - Email of the organisation
  * @param {array} data.sameAs - Social accounts of the organisation
  * @param {string} data.image - Required. A unique banner image.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/WebSite|Schema.org Webpage Docs}
  */
var OrganisationSchema = function OrganisationSchema(props) {
  var schemaOrgJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: props.data.name,
    legalName: props.data.legalName,
    url: props.data.url,
    logo: props.data.logo,
    foundingDate: props.data.foundingDate,
    founders: props.data.founders.map(function (founder) {
      return {
        '@type': 'Person',
        name: founder
      };
    }),
    address: {
      '@type': 'PostalAddress',
      streetAddress: props.data.streetAddress,
      addressLocality: props.data.addressLocality,
      addressRegion: props.data.addressRegion,
      postalCode: props.data.postalCode,
      addressCountry: props.data.addressCountry
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      telephone: props.data.telephone,
      email: props.data.email
    },
    sameAs: props.data.sameAs,
    image: props.data.image
  };
  // console.log(JSON.stringify(schemaOrgJSONLD));

  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    _react2.default.createElement(
      'script',
      { type: 'application/ld+json' },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
}; // ----------------------------------------------------------------------- Imports


OrganisationSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
} : {};

OrganisationSchema.defaultProps = {
  data: {}
};

// ----------------------------------------------------------------------- Export
exports.default = OrganisationSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/seo/lib/OrganisationSchema.js
// module id = 456
// module chunks = 168707334958949